import { useEffect, useState } from "react";
import "../../styles/website/Home.css";
import "../../styles/website/ContactUs.css";
import Layout from "../website/component/Layout.jsx";
import { submitContactConsultation } from "../../api/consultation.js";

/* =========================================================
   آیکون‌ها
   ========================================================= */

const PhoneIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M4 5C4 4.4 4.4 4 5 4H8L10 9L7.5 10.5C8.5 12.7 10.3 14.5 12.5 15.5L14 13L19 15V18C19 18.6 18.6 19 18 19C10.3 19 4 12.7 4 5Z"
      stroke="currentColor"
      strokeWidth="1.7"
      strokeLinejoin="round"
    />
  </svg>
);

const MailIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect
      x="3"
      y="5"
      width="18"
      height="14"
      rx="2"
      stroke="currentColor"
      strokeWidth="1.7"
    />
    <path
      d="M3.5 6L12 13L20.5 6"
      stroke="currentColor"
      strokeWidth="1.7"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const PinIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M12 21C12 21 19 14.5 19 9.5C19 5.36 15.64 2 12 2C8.36 2 5 5.36 5 9.5C5 14.5 12 21 12 21Z"
      stroke="currentColor"
      strokeWidth="1.7"
      strokeLinejoin="round"
    />
    <circle cx="12" cy="9.5" r="2.3" stroke="currentColor" strokeWidth="1.7" />
  </svg>
);

const InstagramIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect
      x="3"
      y="3"
      width="18"
      height="18"
      rx="5"
      stroke="currentColor"
      strokeWidth="1.6"
    />
    <circle cx="12" cy="12" r="4" stroke="currentColor" strokeWidth="1.6" />
    <circle cx="17.2" cy="6.8" r="1.1" fill="currentColor" />
  </svg>
);

const TelegramIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M21 4L2.5 11.3C2 11.5 2 12.3 2.6 12.5L7 14L9 20C9.2 20.5 9.9 20.6 10.2 20.1L12.5 16.7L17 20C17.5 20.4 18.2 20.1 18.3 19.5L21.5 4.8C21.6 4.2 21.5 3.8 21 4Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinejoin="round"
    />
    <path
      d="M7 14L17 6.5"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
    />
  </svg>
);

const ShareIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="6" cy="12" r="2.4" stroke="currentColor" strokeWidth="1.6" />
    <circle cx="18" cy="6" r="2.4" stroke="currentColor" strokeWidth="1.6" />
    <circle cx="18" cy="18" r="2.4" stroke="currentColor" strokeWidth="1.6" />
    <path
      d="M8.1 10.8L15.9 7.2M8.1 13.2L15.9 16.8"
      stroke="currentColor"
      strokeWidth="1.6"
      strokeLinecap="round"
    />
  </svg>
);

const WhatsappIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M4 20L5.2 15.9C4.4 14.6 4 13.1 4 11.5C4 6.8 7.8 3 12.5 3C17.2 3 21 6.8 21 11.5C21 16.2 17.2 20 12.5 20C11 20 9.6 19.6 8.4 18.9L4 20Z"
      stroke="currentColor"
      strokeWidth="1.6"
      strokeLinejoin="round"
    />
    <path
      d="M9 10.3C9 12.6 11 14.6 13.3 14.6C13.6 14.6 13.9 14.3 13.9 14V13.1C13.9 12.8 13.6 12.6 13.4 12.7L12.2 13.1C11.4 12.7 10.8 12 10.4 11.2L10.8 10C10.9 9.8 10.7 9.5 10.4 9.5H9.5C9.2 9.5 9 9.8 9 10.1V10.3Z"
      stroke="currentColor"
      strokeWidth="1.3"
      strokeLinejoin="round"
    />
  </svg>
);

/* =========================================================
   داده‌ها
   ========================================================= */

const quickContacts = [
  {
    icon: <PhoneIcon />,
    title: "تماس تلفنی",
    value: "021-91002233",
    note: "شنبه تا چهارشنبه، ۹ تا ۲۱",
  },
  {
    icon: <MailIcon />,
    title: "ایمیل پشتیبانی",
    value: "support@dokana.ir",
    note: "پاسخ در کمتر از ۲۴ ساعت",
  },
];

// مختصات دفتر مرکزی برای نمایش روی نقشه‌ی سایدبار
const OFFICE_LOCATION = {
  lat: 31.862572011304845,
  lng: 54.37535080124995,
};

// نگاشت گزینه‌های فارسیِ نمایشی به کدهای موضوع مورد انتظار بک‌اند.
// ⚠️ این کدها حدسی‌ان (بر اساس نمونه‌ای که فرستادی: "subject": "consulting").
// حتماً با بک‌اند چک کن که مقدار دقیق هر گزینه چیه و همینجا اصلاحش کن.
const subjectOptions = [
  { label: "پشتیبانی فنی", value: "support" },
  { label: "فروش و تعرفه‌ها", value: "sales" },
  { label: "همکاری و معرفی", value: "consulting" },
  { label: "سایر", value: "other" },
];

const MOBILE_REGEX = /^09\d{9}$/;

/* =========================================================
   کامپوننت اصلی
   ========================================================= */

export default function Contact() {
  const [form, setForm] = useState({
    name: "",
    contact: "",
    subject: subjectOptions[0].value,
    message: "",
  });
  const [sent, setSent] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  useEffect(() => {
    const reduceMotion = window.matchMedia(
      "(prefers-reduced-motion: reduce)",
    ).matches;
    const targets = document.querySelectorAll(".reveal");

    let observer;
    if ("IntersectionObserver" in window && !reduceMotion) {
      observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              entry.target.classList.add("in-view");
              observer.unobserve(entry.target);
            }
          });
        },
        { threshold: 0.15 },
      );
      targets.forEach((el) => observer.observe(el));
    } else {
      targets.forEach((el) => el.classList.add("in-view"));
    }

    return () => observer && observer.disconnect();
  }, []);

  function handleChange(e) {
    const { name, value } = e.target;
    setForm((prev) => ({ ...prev, [name]: value }));
  }

  async function handleSubmit(e) {
    e.preventDefault();
    setError("");

    const fullName = form.name.trim();
    const mobile = form.contact.trim();
    const message = form.message.trim();

    if (!fullName || !mobile || !message) {
      setError("لطفاً همه‌ی فیلدهای ضروری رو پر کن.");
      return;
    }

    // بک‌اند فقط شماره موبایل قبول می‌کنه، نه ایمیل — پس اینجا اعتبارسنجی می‌کنیم.
    if (!MOBILE_REGEX.test(mobile)) {
      setError("لطفاً یک شماره موبایل معتبر وارد کن (مثال: 09123456789).");
      return;
    }

    setLoading(true);
    try {
      await submitContactConsultation({
        full_name: fullName,
        mobile,
        subject: form.subject,
        message,
      });
      setSent(true);
    } catch (err) {
      setError("ارسال پیام با خطا مواجه شد. لطفاً دوباره تلاش کن.");
    } finally {
      setLoading(false);
    }
  }

  return (
    <Layout>
      {/* ---------- Hero ---------- */}
      <section className="contact-hero">
        <div className="wrap contact-hero-inner">
          <h1>چطور می‌تونیم کمکتون کنیم؟</h1>
          <p className="contact-hero-sub">
            سوالی درباره فروشگاه‌سازی، تعرفه‌ها یا همکاری دارید؟ تیم ما همین
            الان آماده‌ی پاسخگوییه.
          </p>
        </div>
      </section>

      {/* ---------- فرم + سایدبار ---------- */}
      <section className="contact-main">
        <div className="wrap contact-grid">
          {/* سایدبار: تماس، آدرس و نقشه */}
          <div className="tile-dark contact-sidebar reveal">
            {quickContacts.map((item) => (
              <div key={item.title}>
                <div className="contact-sidebar-item">
                  <div className="contact-sidebar-icon">{item.icon}</div>
                  <div>
                    <h4>{item.title}</h4>
                    {item.value && (
                      <span className="contact-sidebar-value">
                        {item.value}
                      </span>
                    )}
                    <p>{item.note}</p>
                  </div>
                </div>
              </div>
            ))}

            <div className="contact-sidebar-item">
              <div className="contact-sidebar-icon">
                <PinIcon />
              </div>
              <div>
                <h4>دفتر مرکزی</h4>
                <p>یزد، پارک علم و فناوری یزد</p>
              </div>
            </div>

            {/* نقشه — جایگزین «چت آنلاین» و «ساعات پاسخگویی»، تا انتهای کارت فضای باقی‌مانده رو پر می‌کنه */}
            <div className="contact-sidebar-map">
              <iframe
                title="موقعیت دفتر مرکزی روی نقشه"
                src={`https://www.google.com/maps?q=${OFFICE_LOCATION.lat},${OFFICE_LOCATION.lng}&z=15&output=embed`}
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
                allowFullScreen
              />
            </div>
          </div>

          {/* فرم تماس */}
          <div className="tile contact-form-card reveal">
            <h3>پیام خود را برای ما بفرستید</h3>
            <p>
              فرم زیر رو پر کنید، تیم پشتیبانی در سریع‌ترین زمان باهاتون تماس
              می‌گیره.
            </p>

            {sent ? (
              <p style={{ fontSize: 14, color: "var(--text-1)" }}>
                پیام شما با موفقیت ارسال شد. به‌زودی باهاتون تماس می‌گیریم 🌸
              </p>
            ) : (
              <form onSubmit={handleSubmit}>
                <div className="contact-form-grid">
                  <div className="contact-field">
                    <label htmlFor="name">نام و نام خانوادگی</label>
                    <input
                      id="name"
                      name="name"
                      type="text"
                      placeholder=""
                      value={form.name}
                      onChange={handleChange}
                      disabled={loading}
                      required
                    />
                  </div>
                  <div className="contact-field">
                    <label htmlFor="contact">شماره موبایل</label>
                    <input
                      id="contact"
                      name="contact"
                      type="text"
                      inputMode="tel"
                      placeholder="09xxxxxxxxx"
                      value={form.contact}
                      onChange={handleChange}
                      disabled={loading}
                      required
                    />
                  </div>
                  <div className="contact-field full">
                    <label htmlFor="subject">موضوع پیام</label>
                    <select
                      id="subject"
                      name="subject"
                      value={form.subject}
                      onChange={handleChange}
                      disabled={loading}
                    >
                      {subjectOptions.map((opt) => (
                        <option key={opt.value} value={opt.value}>
                          {opt.label}
                        </option>
                      ))}
                    </select>
                  </div>
                  <div className="contact-field full">
                    <label htmlFor="message">پیام شما</label>
                    <textarea
                      id="message"
                      name="message"
                      placeholder="توضیح بدید چطور می‌تونیم کمکتون کنیم..."
                      value={form.message}
                      onChange={handleChange}
                      disabled={loading}
                      required
                    />
                  </div>
                </div>

                {error && (
                  <p style={{ fontSize: 13, color: "#c0392b", marginTop: 6 }}>
                    {error}
                  </p>
                )}

                <button
                  type="submit"
                  className="btn btn-primary btn-lg"
                  disabled={loading}
                >
                  {loading ? "در حال ارسال..." : "ارسال پیام"}
                </button>
                <p className="contact-form-note">
                  با ارسال این فرم، اطلاعات شما فقط برای پیگیری درخواستتون
                  استفاده می‌شه.
                </p>
              </form>
            )}
          </div>
        </div>
      </section>
    </Layout>
  );
}
